"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReliablePartnerSettingsModal = void 0;
var React = require("react");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Modal_1 = require("@caddigital/sok-ui/lib/components/Modal");
var settingsActions = require("@caddigital/sok-reducers/lib/actions/bid/reliablePartnerSettings");
var ListContainer_1 = require("views/ManagementView/ListContainer");
require("./styles.scss");
var utilityComponents_1 = require("./components/utilityComponents");
var ReliablePartnerSettingsModal = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)(''), identifier = _a[0], setIdentifier = _a[1];
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.bid.reliablePartnerSettings; }), isModalOpen = _b.isModalOpen, errorType = _b.errorType, identifierFetchStatus = _b.identifierFetchStatus;
    var selectedCustomer = (0, react_1.useContext)(ListContainer_1.ModalContext).selectedCustomer;
    var closeModal = function () {
        dispatch(settingsActions.toggleModal()),
            dispatch(settingsActions.clear()),
            setIdentifier('');
    };
    var handleIdentifierChange = (0, react_1.useCallback)(function (event) {
        setIdentifier(event.target.value);
        if (errorType) {
            dispatch(settingsActions.clearStatus());
        }
    }, [errorType, dispatch]);
    var handleIdentifierRequest = (0, react_1.useCallback)(function (identifier) {
        if (selectedCustomer && identifier) {
            dispatch(settingsActions.setApiIdentifierRequest({
                identifier: identifier,
                customerUuid: selectedCustomer.uuid
            }));
            setIdentifier('');
        }
    }, [dispatch, selectedCustomer]);
    var handleDisconnect = (0, react_1.useCallback)(function () {
        if (selectedCustomer) {
            dispatch(settingsActions.unsetApiIdentifierRequest({
                customerUuid: selectedCustomer.uuid
            }));
        }
    }, [selectedCustomer]);
    return (React.createElement(Modal_1.Modal, { isOpen: isModalOpen, className: "reliablePartner-settings-modal" },
        React.createElement(sok_ui_1.Header, { onClose: closeModal }, (0, translation_1.getLocalization)('customer/reliable/partner/modal/header')),
        React.createElement(utilityComponents_1.ModalContainer, { companyName: selectedCustomer.reliablePartnerCompanyName, handleInputChange: handleIdentifierChange, errorType: errorType }),
        React.createElement(sok_ui_1.Footer, { className: "reliablePartner-settings-modal-footer" },
            React.createElement(utilityComponents_1.ModalFooterButtons, { showDisconnect: !!selectedCustomer.reliablePartnerCompanyName, identifier: identifier, closeModal: closeModal, handleIdentifierRequest: handleIdentifierRequest, currentStatus: identifierFetchStatus.value, handleDisconnect: handleDisconnect }))));
};
exports.ReliablePartnerSettingsModal = ReliablePartnerSettingsModal;
